document.addEventListener('DOMContentLoaded', () => {
  const backToTop = document.querySelector('.back-to-top');

  window.addEventListener('scroll', () => {
    // Check if the user has scrolled more than 600px
    if (window.scrollY > 600) {
      backToTop.setAttribute('data-animation-state', 'visible');
    } else {
      backToTop.setAttribute('data-animation-state', 'hidden');
    }
  });
});

